import { SubTypeDTO } from "../../dto/subtype/subtype.dto";
import { SubTypeVersionDTO } from "../../dto/subtype/subtype-version.dto";

export class SubType {
    name: string;
    descriptions: { [key: string]: { language_code: string, translation_text: string } };
    visibility: string;
    subtype_id: number | undefined;
    base_subtype_id: number | undefined;
    maintenance_minutes: number;
    versions: SubTypeVersion[] = [];
  
  constructor(
    name: string, 
    descriptions: { [key: string]: { language_code: string, translation_text: string } },
    visibility: string,
    maintenance_minutes: number = 0,
    subtype_id?: number,
    base_subtype_id?: number
  ) {
    this.name = name;
    this.descriptions = descriptions;
    this.visibility = visibility;
    this.maintenance_minutes = maintenance_minutes;
    this.subtype_id = subtype_id;
    this.base_subtype_id = base_subtype_id;
  }

  public static convertToDTO(subType: SubType): SubTypeDTO {
    return {
      name: subType.name,
      descriptions: subType.descriptions,
      visibility: subType.visibility,
      subtype_id: subType.subtype_id,
      base_subtype_id: subType.base_subtype_id,
      maintenance_minutes: subType.maintenance_minutes,
      versions: subType.versions.map(v => SubTypeVersion.convertToDTO(v))
    };
  }

  public static fromDTO(dto: SubTypeDTO): SubType {
    const subType = new SubType(
      dto.name,
      dto.descriptions,
      dto.visibility,
      dto.maintenance_minutes,
      dto.subtype_id,
      dto.base_subtype_id
    );
    
    if (dto.versions) {
      subType.versions = dto.versions.map(v => SubTypeVersion.fromDTO(v));
    }
    
    return subType;
  }
}

export class SubTypeVersion {
  constructor(
    public version_id: number,
    public subtype_id: number,
    public name: string,
    public descriptions: { [key: string]: { language_code: string, translation_text: string } },
    public valid_from: string,
    public valid_to: string,
    public maintenance_minutes: number,
    public visibility: string
  ) {}

  public static convertToDTO(version: SubTypeVersion): SubTypeVersionDTO {
    return {
      version_id: version.version_id,
      subtype_id: version.subtype_id,
      name: version.name,
      descriptions: version.descriptions,
      valid_from: version.valid_from,
      valid_to: version.valid_to,
      maintenance_minutes: version.maintenance_minutes,
      visibility: version.visibility
    };
  }

  public static fromDTO(dto: SubTypeVersionDTO): SubTypeVersion {
    return new SubTypeVersion(
      dto.version_id,
      dto.subtype_id,
      dto.name,
      dto.descriptions,
      dto.valid_from,
      dto.valid_to,
      dto.maintenance_minutes,
      dto.visibility
    );
  }
}
